export const BrandIconsCDN = {
    Root: "https://res-1.cdn.office.net/files/fabric-cdn-prod_20251008.001/assets/brand-icons/product/svg/",
}

export const BrandIcons = {
    SharePoint16: `${BrandIconsCDN.Root}sharepoint_16x1.svg`,
    SharePoint20: `${BrandIconsCDN.Root}sharepoint_20x1.svg`,

    Teams16: `${BrandIconsCDN.Root}teams_16x1.svg`,
    Teams20: `${BrandIconsCDN.Root}teams_20x1.svg`,

    OneDrive16: `${BrandIconsCDN.Root}onedrive_16x1.svg`,
    OneDrive20: `${BrandIconsCDN.Root}onedrive_20x1.svg`,

    Outlook16: `${BrandIconsCDN.Root}outlook_16x1.svg`,
    Outlook20: `${BrandIconsCDN.Root}outlook_20x1.svg`,

    Word16: `${BrandIconsCDN.Root}word_16x1.svg`,

    Excel16: `${BrandIconsCDN.Root}excel_16x1.svg`,

    PowerPoint16: `${BrandIconsCDN.Root}powerpoint_16x1.svg`,

    OneNote16: `${BrandIconsCDN.Root}onenote_16x1.svg`,
}